import ArPreview from './ArPreview.component';

export default ArPreview;
